import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonAccordionGroup, MenuController, Platform } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from '../menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { PiggyBankService } from 'src/app/services/piggybank/piggybank.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { LevelService } from 'src/app/services/lobby/level.service';
import { LeaderboardService } from 'src/app/services/leaderboard/leaderboard.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { gsap } from 'gsap';
import { AudioService } from 'src/app/services/audio/audio.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from 'src/app/services/codeUtils';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { GradleFile } from '@trapezedev/project/dist/android/gradle-file';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
@Component({
  selector: 'app-all-purpose-drawer',
  templateUrl: './all-purpose-drawer.component.html',
  styleUrls: ['all-purpose-drawer.component.scss'],
})

export class AllPurposeDrawerComponent implements OnInit {
  @ViewChild('accordionGroup', { static: true }) accordionGroup: IonAccordionGroup;

  @Output() drawerClicked: EventEmitter<boolean> = new EventEmitter();

  isCustomerAllowedPiggyBack: boolean = true;
  isDrawerAvailable: boolean = false;
  accordionOpen: boolean = false;
  accordionClosed: boolean = true;
  isAuthenticated: boolean = false;

  @Input() title: string = '';
  isOpen: boolean = false;
  currentLevel: number;
  isCustomerAllowedLeaderboard: boolean = true;
  timeRemaining;

  currentPlayer: any;
  customerId: any;
  tutorialAvailablePiggy: string = "false";
  tutorialAvailableLB: string = "false";
  customer: CustomerModel;
  lbEnabled: boolean;
  piggyEnabled: boolean;
  currentPlayerRank: number;
  showCurrentPlayerRank: boolean = false;
  isBiggerAmount: boolean;
  minimalAPDList;
  protected isMobile: boolean = false;
  protected isPortrait: boolean = false;

  public gameLaunchData: any;
  isFoundInMininalList: any = false;
  constructor(
    private events: EventsService,
    private navigator: Navigator,
    private userSession: UserSessionService,
    private piggyBankService: PiggyBankService,
    private leaderBoardService: LeaderboardService,
    private levelService: LevelService,
    private audioService:AudioService,
    private utils: UtilsService,
    private config:ConfigService,
    private galleryService:GalleryService,
    private platform:Platform
  ) {

    this.levelService.level$.subscribe(res => {
      this.isCustomerAllowedLeaderboard  = this.levelService.checkLeaderBoardAvailable();
      this.userSession.getCustomer().subscribe(
        (customer: CustomerModel) => {
          if (customer) {
            this.customer = customer;
            this.userSession.isAuthenticated().then(isAuth => {
              if(isAuth){
                if (null !== customer.getCustomDataProperty('LB_TUTORIAL_VIEWED')) {
                  this.tutorialAvailableLB = customer.getCustomDataProperty('LB_TUTORIAL_VIEWED');
                }
              }
            })
          }
        });
    })

    this.levelService.level$.subscribe(res => {
      this.isCustomerAllowedPiggyBack  = this.levelService.checkPiggyBankAvailable();
      this.userSession.getCustomer().subscribe(
        (customer: CustomerModel) => {
          if (customer) {
          
            this.userSession.isAuthenticated().then(isAuth => {
              if(isAuth){
                if (null !== customer.getCustomDataProperty('PB_TUTORIAL_VIEWED')) {
                  this.tutorialAvailablePiggy = customer.getCustomDataProperty('PB_TUTORIAL_VIEWED');
                }
              }
            })
          }
        });
      
    })
  }

  ngOnInit(): void {
    this.piggyEnabled = this.config.getConfig().SHOW_PIGGY_BANK_LOBBY === "1" ? true : false;
    this.lbEnabled = this.config.getConfig().SHOW_LB_LOBBY === "1" ? true : false;

    this.adjustOrientation();
    this.minimalAPDList = 
    this.config.getConfig().FEATURE_MINIMAL_APD_VENDOR_LIST || "['KONAMI']";


    this.verifyAuth();
    this.events.subscribe("event:login", () => {
      this.verifyAuth();
    });


    this.galleryService.gameList$.subscribe((data) => {
      this.gameLaunchData = data;
      this.checkForAPDMinimal();
    });
  }
  

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.adjustOrientation();
    this.checkForAPDMinimal();
  }


  adjustOrientation(){
    this.isMobile = this.platform.is('mobile');
    this.isPortrait = this.platform.isPortrait();
  }
  verifyAuth() {
    this.userSession.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      this.levelService.level$.subscribe(res => {
        this.isDrawerAvailable = this.levelService.checkDrawerAvailable();
      })
      if (this.isDrawerAvailable) {
        this.leaderBoardService.getActiveLeaderBoardDetails().subscribe(res => {
          this.userSession.getCustomer().subscribe(
            (customer) => {
                this.customerId = customer.customerId;
            }
        );

        })
      }
    });
  }

  toggleAccordion() {
    this.audioService.playSound("PopupCloseClick")
    this.isOpen = !this.isOpen;
    
    if(this.isOpen){
      if(this.levelService.checkPiggyBankAvailable() && this.piggyEnabled){
        gsap.to('.accordion-container', { duration: 0.3, x: -140 ,ease: "power2.inOut" });
      }
      if(this.levelService.checkLeaderBoardAvailable() && this.lbEnabled){
        gsap.to('.accordion-container', { duration: 0.3, x: -240 ,ease: "power2.inOut" });
      }
    }else {
      gsap.to('.accordion-container', { duration: 0.3, x: 0 ,ease: "power2.inOut" });
    } 
    this.drawerClicked.emit(this.isOpen);
    if (this.isDrawerAvailable && this.isOpen) {
      this.leaderBoardService.getActiveLeaderBoardDetails().subscribe(res => {
        if (!!res.result) {
          if (res.result) {
            this.setTimeLeft(res.payload.timeRemaining);
            if(!!res.payload.customerLeaderboards){
              for(let item of res.payload.customerLeaderboards){
                if((item.customerId === this.customerId) && !isUndefined(item.customerId)){
                  this.currentPlayer = item;
                  this.currentPlayerRank = item.currentRank;

                  const numberString = this.currentPlayerRank.toString();
                  const decimalIndex = numberString.length;
                  if(decimalIndex > 1)
                  {
                    this.isBiggerAmount = true;
                  }else {
                    this.isBiggerAmount = false;
                  }
                  if(this.currentPlayerRank <= 99 ){
                    this.showCurrentPlayerRank = true;
                  }else {
                    this.showCurrentPlayerRank = false;
                  }
                }
              }
            }

          }
        }
      })
    }
  }

  setTimeLeft(timeLeft: number) {
    if (timeLeft <= 0) {
      this.timeRemaining = timeLeft;
      return;
    } else {
      this.timeRemaining = timeLeft;
      if (timeLeft - 1000 >= 0) {
        setTimeout(() => this.setTimeLeft(timeLeft - 1000), 1000);
      }
    }
  }

  protected onClick(context: string): any {
    if (this.isCustomerAllowedPiggyBack && context === 'piggy') {
      if(this.tutorialAvailablePiggy === 'false'){        
        this.navigator.navigateTo('PiggyBankTutorialComponent', { customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true });
        this.levelService.setTutorial("PB_TUTORIAL_VIEWED","true");
      }else {
        this.audioService.playSound("PiggyBankOpen")
        return this.navigator.navigateTo('PiggyBankComponent', { customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true });
      }
    }




    if (this.isCustomerAllowedLeaderboard && context === 'leaderboard') {
      if(this.customer.nickName === null || isUndefined(this.customer.nickName)) {
        this.navigator.navigateTo('LeaderboardCongratsPopupComponent',{ customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true })
      }else {
        return this.navigator.navigateTo('LeaderboardComponent', { customModalClass: 'custom-leaderboard-model-class-transparent', backdropDismiss: true });
      }
    }
  }

  accordianChange(e) {
    if (e.target.value === 'first') {
      this.accordionOpen = true;
      this.accordionClosed = false;
    } else {
      this.accordionClosed = true;
      this.accordionOpen = false;
    }
  }

  checkForAPDMinimal(){
    //Check for vendor_ident and config FEATURE_MINIMAL_APD_LIST
    this.isFoundInMininalList = this.minimalAPDList.includes(this.gameLaunchData.vendor_ident.toUpperCase()) && this.isMobile && this.isPortrait;
    console.log(this.isFoundInMininalList);
  }
}
